module.exports = __webpack_public_path__ + "static/media/permision-granted.c5a59e72.svg";